/* eslint-disable react-hooks/exhaustive-deps */
import { jwtDecode, JwtPayload } from 'jwt-decode'
import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { PATHS } from '@/router/constants'
import { useStore } from '@/store'
import StyledLink from '@/ui/atoms/StyledLink'
import Footer from '@/ui/molecules/Footer'
import Body from '@/ui/organisms/Body'
import StepFour from '@/ui/organisms/singUp/StepFour'
import StepOne from '@/ui/organisms/singUp/StepOne'
import StepThree from '@/ui/organisms/singUp/StepThree'
import StepThreePointFive from '@/ui/organisms/singUp/StepThreePointFive'
import StepTwo from '@/ui/organisms/singUp/StepTwo'
import { isNilOrEmpty, notNilNorEmpty } from '@/utils'

const steps = [
  <StepOne key={'onboarding-step1'} />,
  <StepTwo key={'onboarding-step2'} />,
  <StepThree key={'onboarding-step3'} />,
  <StepThreePointFive key={'onboarding-step3.5'} />,
  <StepFour key={'onboarding-step4'} />,
]

interface DecodedToken extends JwtPayload {
  email: string
  firstName?: string
  lastName?: string
  displayName?: string
}

export const SignUpTemplate: React.FC = () => {
  const {
    currentStep,
    decreaseStep,
    clearAll,
    setEmail,
    setFirstName,
    setLastName,
    setDisplayName,
    setIsDirectBrowserFlow,
    email,
  } = useStore()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const navigate = useNavigate()

  useEffect(() => {
    if (notNilNorEmpty(email) || currentStep !== 0) {
      clearAll()
    }
    if (notNilNorEmpty(token)) {
      const tokenStr = Array.isArray(token) ? token[0] : token
      try {
        const decoded = jwtDecode<DecodedToken>(tokenStr)
        const { email, firstName, lastName, displayName } = decoded
        setEmail(email)
        setFirstName(firstName || '')
        setLastName(lastName || '')
        setDisplayName(displayName || '')
        setIsDirectBrowserFlow(false)
      } catch {
        clearAll()
        navigate(PATHS.SIGN_UP)
      }
    } else {
      setIsDirectBrowserFlow(true)
    }
  }, [])

  return (
    <>
      <Body steps={steps} handleBackStep={decreaseStep} activeStep={currentStep} />
      <Footer>
        {isNilOrEmpty(token) && (
          <>
            Already have an account?{' '}
            <StyledLink to='/login' onClick={clearAll}>
              Log In
            </StyledLink>
          </>
        )}
      </Footer>
    </>
  )
}
